import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.recyclingMaterials.fields.id'),
  },
  {
    name: 'infoMessage',
    label: i18n('entities.recyclingMaterials.fields.infoMessage'),
  },
  {
    name: 'name',
    label: i18n('entities.recyclingMaterials.fields.name'),
  },
  {
    name: 'containerParts',
    label: i18n('entities.recyclingMaterials.fields.containerParts'),
    render: exporterRenders.stringArray(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.recyclingMaterials.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.recyclingMaterials.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
